'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _merge2 = require('lodash/fp/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _assign2 = require('lodash/fp/assign');

var _assign3 = _interopRequireDefault(_assign2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _keyBy2 = require('lodash/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _dropRight2 = require('lodash/dropRight');

var _dropRight3 = _interopRequireDefault(_dropRight2);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _size2 = require('lodash/size');

var _size3 = _interopRequireDefault(_size2);

var _actionHandlers;

exports.default = orderedReducer;

var _constants = require('../constants');

var _query = require('../utils/query');

var _reducers = require('../utils/reducers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOCUMENT_ADDED = _constants.actionTypes.DOCUMENT_ADDED,
    GET_SUCCESS = _constants.actionTypes.GET_SUCCESS,
    LISTENER_RESPONSE = _constants.actionTypes.LISTENER_RESPONSE,
    CLEAR_DATA = _constants.actionTypes.CLEAR_DATA,
    DELETE_SUCCESS = _constants.actionTypes.DELETE_SUCCESS,
    DOCUMENT_REMOVED = _constants.actionTypes.DOCUMENT_REMOVED,
    DOCUMENT_MODIFIED = _constants.actionTypes.DOCUMENT_MODIFIED;

function modifyDoc(collectionState, action) {
  return (0, _reducers.updateItemInArray)(collectionState, action.meta.doc, function (item) {
    return (0, _assign3.default)(item, action.payload.data);
  });
}

function lastDocKey(meta) {
  return meta.subcollections ? (0, _last3.default)(meta.subcollections).doc : meta.doc;
}

function addDoc() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var meta = action.meta,
      payload = action.payload;

  return [].concat((0, _toConsumableArray3.default)(array.slice(0, payload.ordered.newIndex)), [(0, _extends4.default)({ id: lastDocKey(meta) }, payload.data)], (0, _toConsumableArray3.default)(array.slice(payload.ordered.newIndex)));
}

function removeDoc(array, action) {
  return (0, _reject3.default)(array, { id: lastDocKey(action.meta) });
}

function writeCollection(collectionState, action) {
  var meta = action.meta,
      _action$merge = action.merge,
      merge = _action$merge === undefined ? { doc: true, collections: true } : _action$merge;

  if (meta.storeAs) {
    return action.payload.ordered;
  }
  var collectionStateSize = (0, _size3.default)(collectionState);
  var payloadExists = !!(0, _size3.default)(action.payload.ordered);

  if (meta.doc && merge.doc && collectionStateSize) {
    return modifyDoc(collectionState, action);
  }

  if (collectionStateSize && merge.collections) {
    if (!payloadExists) {
      return [];
    }

    var existingKeys = collectionState && (0, _keyBy3.default)(collectionState, 'id');

    return (0, _map3.default)(action.payload.ordered, function (newDocObj) {
      var existingDoc = (0, _get3.default)(existingKeys, newDocObj.id);

      return !!existingDoc && !(0, _isEqual3.default)(existingDoc, newDocObj) ? (0, _extends4.default)({}, existingDoc, newDocObj) : newDocObj;
    });
  }

  if (meta.doc && collectionStateSize) {
    return (0, _reducers.updateItemInArray)(collectionState, meta.doc, function (item) {
      return (0, _merge3.default)(item, action.payload.ordered[0]);
    });
  }

  return action.payload.ordered;
}

var actionHandlers = (_actionHandlers = {}, (0, _defineProperty3.default)(_actionHandlers, DOCUMENT_ADDED, addDoc), (0, _defineProperty3.default)(_actionHandlers, DOCUMENT_MODIFIED, modifyDoc), (0, _defineProperty3.default)(_actionHandlers, DOCUMENT_REMOVED, removeDoc), (0, _defineProperty3.default)(_actionHandlers, DELETE_SUCCESS, removeDoc), (0, _defineProperty3.default)(_actionHandlers, LISTENER_RESPONSE, writeCollection), (0, _defineProperty3.default)(_actionHandlers, GET_SUCCESS, writeCollection), _actionHandlers);

var orderedCollectionReducer = (0, _reducers.createReducer)(undefined, actionHandlers);

function removeLastDocFromMeta(meta) {
  if (!meta.subcollections) {
    return (0, _extends4.default)({}, meta, { doc: undefined });
  }
  var lastSubcollection = (0, _last3.default)(meta.subcollections);
  var modifiedSubcollections = [].concat((0, _toConsumableArray3.default)((0, _dropRight3.default)(meta.subcollections)), [(0, _extends4.default)({}, lastSubcollection, { doc: undefined })]);
  return (0, _extends4.default)({}, meta, { subcollections: modifiedSubcollections });
}

function getStoreUnderKey(action) {
  if (action.meta.oldStoreAs) {
    return action.meta.storeAs || action.meta.collection;
  }
  var queryName = (0, _query.getQueryName)(action.meta);

  if (queryName.includes('?')) {
    return (0, _query.getQueryName)(removeLastDocFromMeta(action.meta));
  }
  var pathArr = (0, _reducers.pathToArr)(queryName);

  if (pathArr.length <= '1') {
    return action.meta.storeAs || action.meta.collection;
  }

  return (0, _dropRight3.default)(pathArr).join('/');
}

function orderedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (!action.type || !action.meta || !action.meta.storeAs && !action.meta.collection) {
    return state;
  }

  if (action.type === CLEAR_DATA) {
    if (action.preserve && action.preserve.ordered) {
      return (0, _reducers.preserveValuesFromState)(state, action.preserve.ordered, {});
    }
    return {};
  }

  if (!Object.prototype.hasOwnProperty.call(actionHandlers, action.type)) {
    return state;
  }

  var storeUnderKey = getStoreUnderKey(action);
  var collectionStateSlice = state[storeUnderKey];
  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, storeUnderKey, orderedCollectionReducer(collectionStateSlice, action)));
}